import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectOptionType } from '../../../../types';

@Pipe({
  name: 'multiValueText',
})
export class SelectMultiValuePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: unknown | null, options: SelectOptionType[]): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (Array.isArray(value)) {
      const selectedOptions: SelectOptionType[] = options.filter((option: SelectOptionType) =>
        value.includes(option.value),
      );

      if (!selectedOptions || !selectedOptions.length)
        return this.translateService.instant('common.selectComponent.all');

      const first = selectedOptions[0]!;

      if (selectedOptions.length === 1) {
        return first.name;
      }

      return `${first.name} +${selectedOptions.length - 1}`;
    }

    if (typeof value === 'string') {
      return value;
    }

    return '';
  }
}
